export default __webpack_public_path__ + "static/Roboto-Bold-75371f53f06181df75f16f2a140533e5.ttf";